import { useEffect } from "react";
import PolicyView from "./view";
import { useNavigate } from "react-router-dom";

export default function Policy() {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js';
    script.type = 'text/javascript';
    script.id = 'otprivacy-notice-script';
    script.setAttribute('settings', 'eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyJ9');

    document.body.appendChild(script);

    script.onload = () => {
      // @ts-expect-error
      window?.OneTrust?.NoticeApi?.Initialized?.then(() => {
        // @ts-expect-error
        window?.OneTrust?.NoticeApi?.LoadNotices([
          'https://privacyportal-cdn.onetrust.com/7bc4e376-ade0-4069-b447-79b713984a3b/privacy-notices/1ef0a230-db30-4fa6-8368-96c76ba2e4bc.json'
        ]);
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <PolicyView
      goBack={goBack}
    />
  );
}